import React, { useState } from "react";
import { useGlobalContext } from "../../hooks/context";
import { totalAmount } from "../../utils/amount";
import useTestPayment from "../../hooks/useTestPayment";
import CustomModal from "../modal/CustomModal";
import PaymentReceipt from "../receipt/PaymentReceipt";
import PaymentClose from "./PaymentClose";

const PaymentButton = () => {
  const [open, setOpen] = useState(false);
  // const [prevPayment, setPrevPayment] = useState(true);
  const { message, onPayment, onClose, paymentId } = useTestPayment();
  const { selectedItems } = useGlobalContext();
  const amount = totalAmount(selectedItems);

  const paymentHandler = async () => {
    setOpen(true);
    // setPrevPayment(false);
    onPayment();
  };

  const closeHandler = () => {
    onClose();
    // setPrevPayment(true);
    setOpen(false);
  };

  let content = "";
  switch (message.toLowerCase()) {
    case "success":
      content = (
        <PaymentReceipt
          message={message}
          paymentId={paymentId}
          onClose={closeHandler}
        />
      );
      break;
    case "cancelled":
      content = (
        <>
          <p className="text-3xl font-semibold tracking-wider">
            Status: {message}
          </p>
          <PaymentClose onClose={closeHandler} />
        </>
      );
      break;
    case "please follow the instructions on the terminal.":
      content = (
        <p className="text-3xl font-semibold tracking-wider">{message}</p>
      );
      break;

    default:
      content = (
        <>
          <p className="text-3xl font-semibold tracking-wider">{message}</p>
          <PaymentClose onClose={closeHandler} />
        </>
      );
      break;
  }

  return (
    <>
      <button
        type="button"
        className="confirm-button"
        disabled={amount <= 0}
        onClick={paymentHandler}
      >
        Pay Now
      </button>
      <CustomModal closeIcon={false} open={open} onClose={closeHandler}>
        <div className="px-5 h-full flex justify-center gap-10 items-center flex-col text-center">
          {content}
        </div>
        {/* {prevPayment ? (
          <div className="px-5 h-full flex justify-center gap-10 items-center flex-col text-center">
            <h3 className="text-[35px] kmd:text-[40px] kxl:text-[30px]">
              Total Amount :{" "}
              <span className="text-4xl font-bold">$ {amount}</span>
            </h3>
            <button
              type="button"
              disabled={amount <= 0}
              className="pay-button"
              onClick={paymentHandler}
            >
              Pay Now
            </button>
            <PaymentClose onClose={closeHandler} />
          </div>
        ) : (
          <div className="px-5 h-full flex justify-center gap-10 items-center flex-col text-center">
            {content}
          </div>
        )} */}
      </CustomModal>
    </>
  );
};

export default PaymentButton;
